import { cn } from '@/lib/utils'

interface Props {
    title: string
    description?: React.ReactNode
    icon?: React.ComponentType<{ className?: string }>
    action?: React.ReactNode
    className?: string
}

export function EmptyState({ title, description, icon: Icon, action, className }: Props) {
    return (
        <div
            className={cn(
                'border-border flex flex-col items-center justify-center gap-2 rounded-md border border-dashed p-8 text-center',
                className,
            )}
        >
            {Icon && <Icon className="text-muted-foreground h-6 w-6" />}
            <div className="text-sm font-medium">{title}</div>
            {description && (
                <div className="text-muted-foreground max-w-md text-xs">{description}</div>
            )}
            {action && <div className="mt-2">{action}</div>}
        </div>
    )
}
